<template>
  <el-card shadow="never" class="l-main-card">
    <div class="l-table-toolbar">
      <l-auth-button type="primary" auth="dev_type_add_btn" @click="showAdd(0)">
        添加
      </l-auth-button>
    </div>
    <l-table
      :data="data"
      v-loading="loading"
      row-key="id"
      default-expand-all
      :tree-props="{ children: 'children', hasChildren: 'hasChildren' }"
    >
      <el-table-column prop="name" label="设备名称" min-width="180">
      </el-table-column>
      <el-table-column prop="img_icon" label="设备图标" min-width="120">
        <template v-slot="{ row }">
          <img class="l-table-img" :src="row.img_icon" />
        </template>
      </el-table-column>
      <el-table-column prop="level" label="层级" min-width="100">
      </el-table-column>
      <el-table-column fixed="right" label="操作" width="250" align="center">
        <template slot-scope="{ row }">
          <l-auth-text-button
            type="primary"
            :auth="row.level == 1 ? 'dev_type_add_btn' : ''"
            @click="showAdd(row.id)"
            ><i class="el-icon-plus"></i>新增品牌</l-auth-text-button
          >
          <span class="l-action-separator">|</span>
          <l-auth-text-button
            type="primary"
            auth="dev_type_edit_btn"
            @click="showEdit(row)"
            ><i class="el-icon-edit"></i>编辑</l-auth-text-button
          >
          <span class="l-action-separator">|</span>
          <l-auth-text-button
            type="danger"
            auth="dev_type_del_btn"
            @click="del(row.id)"
            ><i class="el-icon-delete"></i>删除</l-auth-text-button
          >
        </template>
      </el-table-column>
    </l-table>

    <!--添加弹窗-->
    <l-dialog :visible.sync="add_visible" title="添加设备类型" width="500px">
      <l-dev-type-edit
        @on-success="onAddSuccess"
        :visible.sync="add_visible"
        :pid="pid"
        :name-props="name_props"
      />
      
    </l-dialog>

    <!--编辑弹窗-->
    <l-dialog :visible.sync="edit_visible" title="编辑设备类型" width="500px">
      <l-dev-type-edit
        @on-success="onEditSuccess"
        :visible.sync="edit_visible"
        :id="edit_id"
        :name-props="name_props"
      />
    </l-dialog>
  </el-card>
</template>

<script>
import Edit from "./Edit";
export default {
  name: "l-dev-type",
  components: {
    [Edit.name]: Edit,
  },
  data() {
    return {
      data: [],
      loading: false,

      add_visible: false, //是否显示添加
      pid: "",

      edit_visible: false, //是否显示编辑
      edit_id: 0,

      name_props: "设备类型名称",
      dialogTableVisible: false,
      iconform:[]
    };
  },
  mounted() {
    this.getList();
  },
  methods: {
    //获取列表数据
    getList() {
      this.loading = true;
      this.$_invoke("devType_getList", {
        page: this.page,
        page_size: this.page_size,
        ...this.rel_search_data,
      })
        .then((ret) => {
          this.data = ret.data;
        })
        .finally(() => {
          this.loading = false;
        });
    },

    //显示添加
    showAdd(pid) {
      this.pid = pid;
      if (pid != 0) {
        this.name_props = "品牌名称";
      } else {
        this.name_props = "设备类型名称";
      }
      this.add_visible = true;
    },

    //添加成功回调
    onAddSuccess() {
      this.pid = "";
      this.add_visible = false;
      this.getList();
    },

    //显示编辑
    showEdit(row) {
      this.edit_id = row.id;
      if (row.pid != 0) {
        this.name_props = "品牌名称";
      } else {
        this.name_props = "设备类型名称";
      }
      this.edit_visible = true;
    },

    //编辑成功回调
    onEditSuccess() {
      this.edit_id = "";
      this.edit_visible = false;
      this.getList();
    },

    //删除
    del(id) {
      this.$confirm("删除后该设备类型不可报修,确认删除吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$_invoke(`devType_delete`, { id }).then(() => {
            this.$_msg.success("删除成功");
            this.getList();
          });
        })
        .catch(() => {});
    },
  },
};
</script>
